module.exports = __webpack_public_path__ + "static/media/Add.006522fe.png";